import api from './api.service';

export type AiAgentAuditRow = {
  id: string;
  session_id: string;
  user_id: string;
  company_id: string;
  branch_id: string | null;
  module: string | null;
  page_context: string | null;
  user_message: string;
  intent: string | null;
  persona: string | null;
  tools_called: string | null;
  response_text: string | null;
  action_tier: number | null;
  action_taken: string | null;
  confirmed_by_user: boolean;
  cancelled: boolean;
  error: string | null;
  duration_ms: number | null;
  created_at: string;
};

export type AiAgentAuditResponse = {
  success: boolean;
  page: number;
  pageSize: number;
  total: number;
  items: AiAgentAuditRow[];
};

export async function fetchAiAgentAudit(params: {
  page?: number;
  pageSize?: number;
  companyId?: string;
  sessionId?: string;
  userId?: string;
  module?: string;
  from?: string;
  to?: string;
}): Promise<AiAgentAuditResponse> {
  const res = await api.getClient().get<AiAgentAuditResponse>('/ai-agent/audit', {
    params: {
      page: params.page,
      pageSize: params.pageSize,
      companyId: params.companyId,
      sessionId: params.sessionId,
      userId: params.userId,
      module: params.module,
      from: params.from,
      to: params.to,
    },
  });
  return res.data;
}
